import { render, staticRenderFns } from "./ProjectWordCloudDialog.vue?vue&type=template&id=62064ff2&scoped=true&"
import script from "./ProjectWordCloudDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectWordCloudDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectWordCloudDialog.vue?vue&type=style&index=0&id=62064ff2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62064ff2",
  null
  
)

export default component.exports